
export const windowOpen = (data: any) => {
  if (typeof data === "string") {
    window.open(data, "_blank");
    return;
  }
  const state = data.state ?? {};
  const search = data.search ?? "";
  // JSON化後に空になる（undefinedしか持たない）stateはクエリ不要
  const serializedState = JSON.stringify(state);
  if (serializedState === "{}") {
    window.open(`${data.pathname}${search}`, "_blank");
    return;
  }
  const dataStr = encodeURIComponent(serializedState);
  const dataSeparator = search ? "&" : "?";
  window.open(`${data.pathname}${search}${dataSeparator}data=${dataStr}`, "_blank");
};

export const getState = (location: any) => {
  if (location.state == undefined) {
    const stateStr = new URLSearchParams(location.search).get("data");
    if (!stateStr) return {};
    return JSON.parse(decodeURIComponent(String(stateStr)));
  } else {
    return location.state;
  }
};

export const pushWithModifier = (
  e: { metaKey?: boolean; ctrlKey?: boolean },
  history: { push: (data: any) => void },
  data: any
) => {
  if (e?.metaKey || e?.ctrlKey) {
    windowOpen(data);
    return;
  }
  history.push(data);
};
